export const tourData = [
  {
    id: 1,
    city: "new york",
    img: "./img/newyork.jpeg",
    name: "new york bridge tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 2,
    city: "paris",
    img: "./img/paris.jpeg",
    name: "paris lights tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 3,
    city: "london",
    img: "./img/london.jpeg",
    name: "london royal palace tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 4,
    city: "tokyo",
    img: "./img/tokyo.jpeg",
    name: "tokyo sushi tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 5,
    city: "singapore",
    img: "./img/singapore.jpeg",
    name: "santosha island tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 6,
    city: "Hongkong",
    img: "./img/hongkong.jpeg",
    name: "big buddha tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 7,
    city: "Auckland",
    img: "./img/auckland.jpeg",
    name: "Auckland city tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 8,
    city: "sydney",
    img: "./img/sydney.jpeg",
    name: "Opera house tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  }
];
